import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useParams } from "react-router-dom";
import { Store } from "../../../Model/Setting/Store";
import { TaxType } from "../../../Model/Setting/TaxType";
import { Country } from "../../../Model/Setting/Country";
import { setToast } from "../../../Util/Toast";
import AddUpdateForm from "../../../Components/AddUpdateForm";
import { useEffect, useState } from "react";
import { Breadcrumb, Button } from "react-bootstrap";
import FieldDescription from "../../../Components/FieldDescription";
import Notes from "../../../Components/Notes";
import ActivityLogs from "../../../Components/ActivityLogs";
import { TAX_TYPE_LIST, TAX_TYPE_TITLE } from "../../../Routes/Setting/TaxType";
import AddUpdateTaxType from "../../../Pages/Setting/TaxType/AddUpdate";

interface AddUpdateProps {
  title?: any;
  listRoute?: any;
  isNotUpdate?: any;
  onChangeModalStatus?: (status: boolean) => void;
}

const AddUpdate: React.FC<AddUpdateProps> = ({
  title,
  listRoute,
  isNotUpdate,
  onChangeModalStatus,
}: any) => {
  let { id }: any = useParams();
  if (isNotUpdate) {
    id = null;
  }
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState<any>({});
  const [formError, setFormError] = useState<string | null>(null);
  const [isShows, setIsShows] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState("notes");
  const [taxTypeModalStatus, setTaxTypeModalStatus] = useState(false);

  const formFields = [
    {
      id: "inputtax_type_id",
      label: "Tax Type",
      type: "select",
      col: 6,
      name: "tax_type_id",
      placeholder: "Select an Tax Type",
      searchField: "title",
      model: TaxType,
      // validate: [
      //   {
      //     rule: (value: any) => !!value,
      //     message: "Tax Type is required",
      //   },
      // ],
      description: "Choose the applicable tax type for the store/warehouse.",
      addNewBtnStatus: true,
      onChangeModalStatus: (status: boolean) => setTaxTypeModalStatus(status),
      modalStatus: taxTypeModalStatus,
      widget: (
        <AddUpdateTaxType
          title={TAX_TYPE_TITLE}
          listRoute={TAX_TYPE_LIST}
          isNotUpdate={true}
          onChangeModalStatus={(status: boolean) =>
            setTaxTypeModalStatus(status)
          }
        />
      ),
    },
    {
      id: "inputcountry_id",
      label: "Country*",
      type: "select",
      col: 6,
      name: "country_id",
      placeholder: "Select an Country",
      searchField: "name",
      model: Country,
      addNewBtnStatus: false,
      validate: [
        {
          rule: (value: any) => !!value,
          message: "Country is required",
        },
      ],
      description:
        "Indicate the country in which the store/warehouse is located.",
    },
    {
      id: "inputName",
      label: "Name*",
      type: "text",
      col: 6,
      name: "name",
      placeholder: "Select an Name",
      validate: [
        {
          rule: (value: any) => !!value,
          message: "Name is required",
        },
      ],
      description:
        "Enter a unique and descriptive name for the store/warehouse.",
    },
    {
      id: "inputtax_number",
      label: "Tax Number",
      type: "text",
      col: 6,
      name: "tax_number",
      placeholder: "Select an Tax Number",
      // validate: [
      //   {
      //     rule: (value: any) => !!value,
      //     message: "Tax Number is required",
      //   },
      // ],
      description:
        "Specify the tax identification number associated with the store/warehouse.",
    },
    {
      id: "inputcity",
      label: "City*",
      type: "text",
      col: 6,
      name: "city",
      placeholder: "Enter Your City",
      validate: [
        {
          rule: (value: any) => !!value,
          message: "City is required",
        },
      ],
      description: "Provide the city where the store/warehouse is situated.",
    },
    {
      id: "inputstate",
      label: "State*",
      type: "text",
      col: 6,
      name: "state",
      placeholder: "Enter Your State",
      validate: [
        {
          rule: (value: any) => !!value,
          message: "State is required",
        },
      ],
      description: "Specify the state or region of the store/warehouse.",
    },
    {
      id: "inputzipcode",
      label: "Zip Code*",
      type: "number",
      col: 6,
      name: "zipcode",
      placeholder: "Enter Your Zip Code",
      validate: [
        {
          rule: (value: any) => !!value,
          message: "Zip Code is required",
        },
      ],
      description:
        "Enter the postal code or ZIP code of the store/warehouse location.",
    },
    {
      id: "inputaddress_line_1",
      label: "Address Line 1*",
      type: "text",
      col: 6,
      name: "address_line_1",
      placeholder: "Enter Your Address Line 1",
      validate: [
        {
          rule: (value: any) => !!value,
          message: "Address Line 1 is required",
        },
      ],
      description:
        "Provide the complete address in address Line1 & Line 2 Field including street details, for the store/warehouse.",
    },
    {
      id: "inputaddress_line_2",
      label: "Address Line 2",
      type: "text",
      col: 6,
      name: "address_line_2",
      placeholder: "Enter Your Address Line 2",
    },
    {
      id: "inputis_default",
      label: "Is Default",
      type: "checkbox",
      confirmation: true,
      col: 6,
      name: "is_default",
      placeholder: "Enter Your Is Default",
      description:
        "Select the checkbox if you would like to make the default Store/Warehouse to use in the System.",
    },
  ];

  const navigate = useNavigate();
  const [customSubmitting, setCustomSubmitting] = useState(false); // State variable to track form submission status
  const handleCustomSubmit = async (formData: any) => {
    setCustomSubmitting(true);
    let inputData = Object.assign({}, formData);
    // Extracting values after underscore and converting to numbers
    if (inputData.tax_type_id) {
      const taxTypeIdNumber = parseInt(inputData.tax_type_id.value);
      inputData.tax_type_id = taxTypeIdNumber;
    }
    const countryIdNumber = parseInt(inputData.country_id.value);
    // Updating the object with the converted values
    inputData.country_id = countryIdNumber;
    try {
      if (inputData.id) {
        let item = await Store.$query().find(inputData.id);

        item.$attributes = {
          ...item.$attributes,
          ...inputData,
        };

        item = await item.$save();
        setToast("success", `${title} Successfully Updated`);
      } else {
        await Store.$query().store(inputData);
        setToast("success", `${title} Successfully Added`);
      }
      if (onChangeModalStatus) {
        onChangeModalStatus(false);
      } else {
        navigate(`${listRoute.toLowerCase().replace(" ", "-")}`);
      }
    } catch (error: any) {
      if (error.response?.data?.errors) {
        setFormError(error.response.data.errors);
      } else if (error.response?.data?.message) {
        setFormError(error.response.data.message);
      } else {
        setToast("error", "An error occurred while processing your request");
      }
    } finally {
      setCustomSubmitting(false);
    }
  };

  const getFormData = async (itemId: string) => {
    const item: any = await Store.$query()
      .with(["country", "taxType"])
      .find(itemId);

    return item.$attributes;
  };

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        try {
          setLoading(true);
          const itemData = await getFormData(id);
          let data = itemData;
          if (data["country_id"]) {
            data["country_id"] = {
              label: itemData.country["name"],
              value: itemData.country["id"],
            };
          }

          if (data["tax_type_id"]) {
            data["tax_type_id"] = {
              label: itemData.tax_type["title"],
              value: itemData.tax_type["id"],
            };
          }
          setFormData(data);
          setLoading(false);
        } catch (error: any) {
          setToast("error", error.response.data.message);
        }
      } else {
        setLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleHelpButtonClick = () => {
    setIsShows(!isShows);
    const formBottom = document.getElementById("form-bottom");
    if (formBottom) {
      formBottom.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };
  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
        <Breadcrumb.Item href="/stores">Stores/Warehouses</Breadcrumb.Item>
        <Breadcrumb.Item active className="fw-bold">
          {!id ? "Add Stores/Warehouses" : "Edit Stores/Warehouses"}
        </Breadcrumb.Item>
      </Breadcrumb>
      <div>
        <span style={{ float: "inline-end" }}>
          <Button variant="outline-secondary" onClick={handleHelpButtonClick}>
            Need Help?
          </Button>
        </span>
        <AddUpdateForm
          formFields={formFields}
          model={Store}
          title={title}
          customFormSubmit={handleCustomSubmit}
          dynamicFormData={formData}
          listRoute={listRoute}
          dynamicFormError={formError}
          isNotUpdate={isNotUpdate}
          customSubmitting={customSubmitting}
          loadingStatus={loading}
          onChangeModalStatus={onChangeModalStatus}
        />
      </div>
      {id && (
        <div className="card mt-4" style={{ marginBottom: "30px" }}>
          <div className="card-header d-flex">
            <h5
              style={{ cursor: "pointer", fontSize: "17px" }}
              className={`mb-0 me-3 ${
                activeTab === "notes" ? "text-primary" : ""
              }`}
              onClick={() => setActiveTab("notes")}
            >
              Notes
            </h5>
            <h5
              style={{ cursor: "pointer", fontSize: "17px" }}
              className={`mb-0 me-3 ${
                activeTab === "activityLogs" ? "text-primary" : ""
              }`}
              onClick={() => setActiveTab("activityLogs")}
            >
              Activity Logs
            </h5>
          </div>

          <div
            className="card-body"
            style={{
              height: "auto",
              overflow: "auto",
              backgroundColor: "#e4e4e4",
            }}
          >
            {activeTab === "notes" && <Notes id={id} model={Store} />}
            {activeTab === "activityLogs" && (
              <ActivityLogs auditable_type={"STORE"} id={id} />
            )}
          </div>
        </div>
      )}
      <div id="form-bottom">
        <FieldDescription
          title={title}
          formFields={formFields}
          isShows={isShows}
        />
      </div>
    </>
  );
};

export default AddUpdate;
